import React from "react";
import {
  Box
} from "@mui/material";

import GrassrootsPage from "./GrassrootsPage"


export default function Grassroots() {
  return (
      <Box id="grassroots">
        <GrassrootsPage/>
      </Box>
  );
}